import React from "react";
import { AnswerTypeEnum } from "__generated__/globalTypes";
import { CourseQuizQuestion } from "../types";
import EssayQuestion from "./EssayQuestion";
import LikertQuestion from "./LikertQuestion";
import SingleChoiceQuestion from "./SingleChoiceQuestion";
import styles from "./QuizQuestion.module.css";

interface CourseQuizProps {
  question: CourseQuizQuestion;
  hasSubmitted?: boolean;
  hasCompleted: boolean;
}

const QuizQuestion = ({ question, hasCompleted, hasSubmitted = false }: CourseQuizProps) => {
  const questionType = question.answers[0]?.type;

  return (
    <li className={styles.question}>
      {questionType === AnswerTypeEnum.LIKERT && <LikertQuestion question={question} />}
      {questionType === AnswerTypeEnum.SINGLE_CHOICE && (
        <SingleChoiceQuestion
          question={question}
          hasPassed={hasCompleted}
          hasSubmitted={hasSubmitted}
        />
      )}
      {questionType === AnswerTypeEnum.ESSAY && <EssayQuestion question={question} />}
    </li>
  );
};

export default QuizQuestion;
